import {FlowList} from './flow';

export default ({ initialState = {}, handlers = {}, flows = new FlowList() }) => {
  flows.mergeInitialState(initialState);

  return (state = flows.getInitialState(), action) => {
    const composed = {
      ...flows.getReducers(),
      ...handlers,
    };

    return composed[action.type]
      ? composed[action.type](state, action)
      : state;
  };
}
